import { filter } from "rxjs/operators";
import { CertificateService } from "./../../services/certificate.service";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import * as _ from "lodash";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { CommunicationService } from "../../services/communication.service";
import { EventsAttendanceService } from "../../services/events-attendance.service";
import { ProfileService } from "../../services/profile.service";
import { AudienceListWidgetComponent } from "../audience-list-widget/audience-list-widget.component";
import { ContactDetailsWidgetComponent } from "../contact-details-widget/contact-details-widget.component";
import { LoaderService } from "../../services/loader.service";
import { CalendarService } from "../../services/calendar.service";
import { NotificationServices } from "../../services/notification.service";
import { AnalyticsService } from "../../services/analytics.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: "app-calendar-event-details",
  templateUrl: "./calendar-event-details.component.html",
  styleUrls: ["./calendar-event-details.component.scss"],
})
export class CalendarEventDetailsComponent implements OnInit {
  role = this.profileService.profile.role;
  eventId: any;
  eventData: any = null;
  eventDataRegistrations: any = null;

  staffId: any;

  eventChip = "";
  checkedIn = false;
  rsvped = false;
  basePath = "";
  cdnBase = "";

  isStaff = this.profileService.isStaff;

  allDay: boolean = false;
  isSent: boolean = true;
  qrCodeText = "";
  showQRCode = true;

  get isAfterEvent() {
    let now = moment();
    if (now.isAfter(moment(this.eventData.extraData.endTime))) return true;
    else return false;
  }

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private activeRoute: ActivatedRoute,
    private eventService: EventsAttendanceService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private communicationService: CommunicationService,
    private certificateServices: CertificateService,
    private loaderService: LoaderService,
    private calendarServices: CalendarService,
    private notificationServices: NotificationServices,
    private analytics: AnalyticsService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((data) => {
      if (data.id) {
        this.eventId = data.id;
        this.communicationService.getCommunicationById(this.eventId).subscribe((communication) => {
            this.eventService.getAttendanceById(this.eventId).subscribe((res) => {             
                this.isSent = !res.notFound;               
                if (res.notFound) 
                {
                  this.eventData = communication;
                  this.eventDataRegistrations = [];
                  this.rsvped=false;
                  this.checkedIn=false;
                  this.updateEventChip();
                } 
                else 
                {
                  this.eventDataRegistrations = res.registrations;
                  this.eventService.getCheckInStatus(this.eventId, this.profileService.identity.userIdRole)
                    .subscribe((status) => {
                      this.rsvped = status.rsvp;
                      this.checkedIn = status.checkedIn;
                      this.eventData = communication;
                      this.checkAllDay(this.eventData);
                      this.staffId = communication.staffId;                     
                      this.updateEventChip();
                      this.eventData.registrations =
                        this.eventDataRegistrations.slice(0, 39);
                    });
                }

                setTimeout(() => {
                  this.qrCodeDisplay();
                }, 500);

              });
          });

        this.certificateServices
          .getThumbnails()
          .toPromise()
          .then((response) => {
            let s3public =
              "https://" +
              response.s3PublicRepository +
              ".s3.us-west-2.amazonaws.com/";
            this.basePath = `https://${response.s3PublicRepository}.s3.us-west-2.amazonaws.com/`;
            this.cdnBase = s3public;
          });
      }
    });
  }

  checkAllDay(eventData) {
    if (eventData.extraData.startTime == eventData.extraData.endTime) {
      this.allDay = true;
    } else {
      this.allDay = false;
    }
  }

  contactDetails(id) {
    this.profileService.getProfileById(id).subscribe((contact) => {
      let selectedContact = contact;
      const dialogRef = this.dialog.open(ContactDetailsWidgetComponent, {
        data: selectedContact,
      });
    });
  }

  printPage() {
    window.print();
  }

  goBack() {
    let role = this.role.toLocaleLowerCase();
    if (this.isStaff) {
      this.router.navigate([role, "communications-log"]);
    } else {
      this.router.navigate([role, "feeds"]);
    }
  }

  checkIn() {
    this.analytics.sendEvent("User Click", "Check In");
    swal.fire({
      title: `<strong v3-translate><span v3-translate>Check in to event?</span><hr/></strong>`,
      html: `<div v3-translate style="text-align:center;">
        <span v3-translate>
          Please confirm that you are attending this event. Your attendance will be recorded when you 
          <br>check in.
        </span>
      </div>`,
      backdrop: false,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: `
      <div
        class="btn btn-warning"
        style="background-color: #FF4D00 !important; color:white;"
        v3-translate>
        Cancel
      </div>
    `,

      cancelButtonAriaLabel: "Cancel",

      confirmButtonText: `
      <div
        class="btn btn-primary"
        style="background-color: #0089FF !important;"
        v3-translate>
        Continue
      </div>
    `,

      confirmButtonAriaLabel: "Continue",

      reverseButtons: true,

      customClass: {
        popup: "bus-alert-popup",
        cancelButton: "no-bg-cancel",
        confirmButton: "yes-confirm-btn"
      },

      buttonsStyling: false

    }).then((result) => {

      if (result.isConfirmed) {

        const userId =
          this.profileService.identity.userIdRole;

        const req = {
          attendeeId: userId,
          channel: "Web",
          role: this.role
        };

        this.eventService
          .checkinEvent(this.eventId, req)
          .subscribe(

            (res) => {

              console.log(res);

              if (res.checkIn) {

                this.toastr.success(
                  "Successfully checked in"
                );

                this.checkedIn = true;
                this.showCheckIn = false;

              } else {

                if (res.hasError) {

                  this.toastr.warning(
                    res.errorMessage
                  );

                } else {

                  this.toastr.warning(
                    "Could not RSVP in. Try again next to the Event start time."
                  );

                }
              }
            },

            (error) => {

              console.error(
                "Check in error:",
                error
              );

              this.toastr.warning(
                "Could not check in. Try again."
              );
            }
          );
      }
    });

  const confirmBtn = swal.getConfirmButton();

  if (confirmBtn) {
    confirmBtn.style.background = "none";
    confirmBtn.style.borderWidth = "0px";
    confirmBtn.style.border = "none";
  }

  const cancelBtn = swal.getCancelButton();

  if (cancelBtn) {
    cancelBtn.style.background = "none";
    cancelBtn.style.borderWidth = "0px";
    cancelBtn.style.border = "none";
  }
}

  getCheckInStatus(registrations) {
    const id = this.profileService.identity.userIdRole;

    let user = _.find(registrations, { attendeeId: id });

    if (user) this.checkedIn = true;
    else this.checkedIn = false;
  }

  getLink(link) {

    return (link.includes('https') ? link : `//${link}`)

  }  

  rsvp() {
    this.analytics.sendEvent("User Click", "RSVP");
    swal.fire({
      title: `<strong v3-translate><span v3-translate>RSVP to event?</span><hr/></strong>`,
      html: `<div v3-translate style="text-align:center;">
        <span v3-translate>
          Your name will be added to the list of people who will join this meeting.
        </span>
      </div>`,

      backdrop: false,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,

      cancelButtonText: `
      <div
        class="btn btn-warning"
        style="background-color: #FF4D00 !important; color:white;"
        v3-translate>
        Cancel
      </div>
    `,

      cancelButtonAriaLabel: "Cancel",

      confirmButtonText: `
      <div
        class="btn btn-primary"
        style="background-color: #0089FF !important;"
        v3-translate>
        Yes, Confirm
      </div>
    `,

      confirmButtonAriaLabel: "Yes, Confirm",

      reverseButtons: true,

      customClass: {
        popup: "bus-alert-popup",
        cancelButton: "no-bg-cancel",
        confirmButton: "yes-confirm-btn"
      },

      buttonsStyling: false

    }).then((result) => {

      if (result.isConfirmed) {

        const userId =
          this.profileService.identity.userIdRole;

        const req = {
          attendeeId: userId,
          channel: "Web",
          role: this.role
        };

        this.eventService
          .checkinEvent(this.eventId, req)
          .subscribe(

            (res) => {

              console.log(res);

              if (res.rsvp) {

                this.toastr.success(
                  `Successfully RSVP'd`
                );

                this.rsvped = true;
                this.showRsvp = false;

              } else {

                if (res.hasError) {

                  this.toastr.warning(
                    res.errorMessage
                  );

                } else {

                  this.toastr.warning(
                    "Could not RSVP in. Try again next to the Event start time."
                  );

                }
              }
            },

            (error) => {

              console.error("RSVP error:", error);

              this.toastr.warning(
                "Could not RSVP. Try again."
              );
            }
          );
      }
    });

  const confirmBtn = swal.getConfirmButton();

  if (confirmBtn) {
    confirmBtn.style.background = "none";
    confirmBtn.style.borderWidth = "0px";
    confirmBtn.style.border = "none";
  }

  const cancelBtn = swal.getCancelButton();

  if (cancelBtn) {
    cancelBtn.style.background = "none";
    cancelBtn.style.borderWidth = "0px";
    cancelBtn.style.border = "none";
  }
}


  openAudienceList(item) {
    // TODO: get students & parents from item
    this.dialog
      .open(AudienceListWidgetComponent, {
        disableClose: false,
        width: "600px",
        data: {
          list: item,
          entity: "communication",
          entityId: item.id,
          isEngagement: true,
        }, // FIXME: item.students & item.parents
      })
      .afterClosed()
      .subscribe((res) => {
        if (res?.print) {
          const role = this.profileService.profile.role.toLocaleLowerCase();
          const list: NavigationExtras = {
            state: {
              list: res.list,
              eventData: this.eventData,
            },
          };
          this.router.navigate([`${role}/events/print-attendance`], list);
        }
      });
  }

  download(item) {
    const file = item.extraData.eventFile;

    if (file.startsWith('data:')) {
      const arr = file.split(',');
      const mime = arr[0].match(/:(.*?);/)?.[1] || 'application/octet-stream';
      const bytes = atob(arr[1]);
      const byteNumbers = new Array(bytes.length);

      for (let i = 0; i < bytes.length; i++) {
        byteNumbers[i] = bytes.charCodeAt(i);
      }

      const blob = new Blob([new Uint8Array(byteNumbers)], { type: mime });
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, '_blank');
      return;
    }

    window.open(encodeURI(`${this.cdnBase}${file}`), '_blank');
  }
  
  blobPdfFromBase64String = (base64String) => {
    const byteArray = Uint8Array.from(
      atob(base64String)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    return new Blob([byteArray], { type: "application/pdf" });
  };

  viewQR() {
    this.analytics.sendEvent("User Click", "View QR Code");
    let userType = this.profileService.profile.role;
    console.log(userType);
    if (
      userType == "Administrator" ||
      userType == "Teacher" ||
      userType == "Counselor"
    ) {
      this.router.navigate([
        userType.toLocaleLowerCase(),
        "events",
        "id",
        this.eventId,
        "qr",
      ]);
    } else {
      this.router.navigate([
        userType.toLocaleLowerCase(),
        "events",
        "id",
        this.eventId,
        "qr",
      ]);
    }
  }

  viewAllAttendees() {
    this.eventData.registrations = this.eventDataRegistrations;
  }

  viewEngagement(type) {
    switch (type) {
      case "rsvp":
        this.dialog
          .open(AudienceListWidgetComponent, {
            disableClose: false,
            width: "600px",
            data: {
              list: this.eventDataRegistrations
                .filter((r) => r.rsvp != null)
                .map((c) => {
                  return { target: c.role, targetId: c.attendeeId };
                }),
              entity: "communication",
              audienceType: `RSVP'd`,
              isEngagement: true,
              // entityId: item.id
            }, // FIXME: item.students & item.parents
          })
          .afterClosed()
          .subscribe((res) => {
            if (res?.print) {
              const role = this.profileService.profile.role.toLocaleLowerCase();
              const list: NavigationExtras = {
                state: {
                  list: res.list,
                  eventData: this.eventData,
                },
              };
              this.router.navigate([`${role}/events/print-attendance`], list);
            }
          });
        break;
      case "received":
        this.dialog
          .open(AudienceListWidgetComponent, {
            disableClose: false,
            width: "600px",
            data: {
              // list: item,
              entity: "communication",
              audienceType: `Received`,
              isEngagement: true,
              // entityId: item.id
            }, // FIXME: item.students & item.parents
          })
          .afterClosed()
          .subscribe((res) => {
            if (res?.print) {
              const role = this.profileService.profile.role.toLocaleLowerCase();
              const list: NavigationExtras = {
                state: {
                  list: res.list,
                  eventData: this.eventData,
                },
              };
              this.router.navigate([`${role}/events/print-attendance`], list);
            }
          });
        break;
      case "checked in":
        this.dialog
          .open(AudienceListWidgetComponent, {
            disableClose: false,
            width: "600px",
            data: {
              list: this.eventDataRegistrations
                .filter((r) => r.checkIn != null)
                .map((c) => {
                  return { target: c.role, targetId: c.attendeeId };
                }),
              entity: "communication",
              audienceType: `Checked In`,
              isEngagement: true,
              // entityId: item.id
            }, // FIXME: item.students & item.parents
          })
          .afterClosed()
          .subscribe((res) => {
            if (res?.print) {
              const role = this.profileService.profile.role.toLocaleLowerCase();
              const list: NavigationExtras = {
                state: {
                  list: res.list,
                  eventData: this.eventData,
                },
              };
              this.router.navigate([`${role}/events/print-attendance`], list);
            }
          });
        break;

      default:
        break;
    }
  }

  updateBtnDisable(type) {
    let now = moment();
    const eventTime = moment(this.eventData.startDate);

    if (type == "RSVP") {
      if (now.isBefore(eventTime)) {
        return null;
      } else return true;
    }

    if (type == "CheckIn") {
      if (now.isAfter(eventTime)) {
        return null;
      } else return true;
    }
  }

  showRsvp = false;
  showCheckIn = false;
  updateEventChip() { 
    let now = moment();
    const eventStart = moment(this.eventData.extraData.startTime);
    const eventEnd = moment(this.eventData.extraData.endTime);

    if (now.isBefore(eventStart)) {
      this.eventChip = "Upcoming";
      this.showRsvp = this.rsvped ? false : true;
      return;
    }
    if (now.isBetween(eventStart, eventEnd)) {
      
      this.eventChip = "Started";
      this.showRsvp =  this.rsvped ? false : true;;
      this.showCheckIn = this.checkedIn ? false : (this.eventData.extraData.IsRsvpOnly ? this.rsvped == true : (this.eventData.extraData.IsPrivate ? this.rsvped == true : true))     // (this.eventData.extraData.IsRsvpOnly ? (this.rsvped == true : false): true);
      return;
    }
    if (now.isAfter(eventEnd)) {
      this.eventChip = "Ended";
      return;
    }     
  }
  
  qrCodeDisplay() {    
    let now = moment();
    const eventStart = moment(this.eventData.extraData.startTime);
    const eventEnd = moment(this.eventData.extraData.endTime);
    if (now.isBetween(eventStart, eventEnd)) {
      const parentId = this.profileService.identity.userIdRole;
      const userRole = this.profileService.profile.role;
      const origin = window.location.origin;
      this.qrCodeText = origin + "/auth/event-qr-checkin/" + parentId + "/" + userRole + "/" + this.eventId;
    }
    else {
      this.qrCodeText = this.eventId + " | " + this.eventData.name + " | " + this.eventData.extraData.startTime;
    }
    console.log(this.qrCodeText)
  }

  addToCal(feed: any) {
    let userType = this.profileService.profile.role;
    console.log(feed);
    let startDate = feed.extraData.startTime;
    let endDate = feed.extraData.endTime;
    this.loaderService.setHttpProgressStatus(true);
    this.calendarServices
      .createEvent(
        feed.name,
        startDate,
        endDate,
        this.profileService.identity.userIdRole
      )
      .subscribe(
        (res) => {
          this.loaderService.setHttpProgressStatus(false);
          this.notificationServices.showSuccessToast(
            `New Event has been added successfully.`
          );
          // this.router.navigate([`/${userType.toLocaleLowerCase()}/calendar`]);
        },
        (error) => {
          this.notificationServices.showInfoToast(error);
        }
      );
  }
  
  getHtml(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
